import { Icon, IconsEnum } from 'components/Icons';
import { AnchorLink } from 'components/anchorLink';
import { selectIppicaTodayDictionary } from 'features/ippica/selectors';
import dynamic from 'next/dynamic';
import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { convertInCurrencyValueByPrizeInfo } from 'utility/functions';
import { IppicaTableRowInfoBox } from '../ippicaTableRowInfoBox';
import styles from './IppicaTabelRowInfoRenderer.module.scss';

export type IppicaTableRowInfoRendererProps = {
  keyAvvenimento: string;
};
export const IppicaTableRowInfoRenderer = ({ keyAvvenimento }: IppicaTableRowInfoRendererProps) => {
  const {
    codiceProgramma,
    numeroAvvenimento,
    numeroCavalliPartenti,
    importoPremio,
    valutaPremio = '',
    nazione,
    distanza,
    pista,
    meteo,
  } = useSelector(selectIppicaTodayDictionary(keyAvvenimento)) ?? {};

  const currencyPrizeInfo = useMemo(
    () =>
      !importoPremio
        ? 'N.D.'
        : convertInCurrencyValueByPrizeInfo(+importoPremio, { currencyPrize: valutaPremio, nation: nazione }),
    [importoPremio, nazione, valutaPremio]
  );

  return (
    <React.Fragment>
      <IppicaTableRowInfoBox containerClassName={styles.partenti}>{numeroCavalliPartenti!}</IppicaTableRowInfoBox>
      <IppicaTableRowInfoBox containerClassName={styles.montepremi}>{currencyPrizeInfo}</IppicaTableRowInfoBox>
      <IppicaTableRowInfoBox containerClassName={styles.distanza}>{distanza!} m</IppicaTableRowInfoBox>
      <IppicaTableRowInfoBox containerClassName={styles.pista}>{pista! || ''}</IppicaTableRowInfoBox>
      <IppicaTableRowInfoBox containerClassName={styles.meteo}>{meteo || '-'}</IppicaTableRowInfoBox>
      <AnchorLink href={`/ippica/${codiceProgramma}-${numeroAvvenimento}`} className={styles.button}>
        <Icon
          iconId={IconsEnum.DOUBLE_CHEVRON_RIGHT}
          className={styles.iconChevron}
          color="var(--color-on-bg-primary)"
        />
      </AnchorLink>
    </React.Fragment>
  );
};
